import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from 'src/app/auth/auth.service';

@Component({
  selector: 'app-page-not-found',
  templateUrl: './page-not-found.component.html',
  styleUrls: ['./page-not-found.component.scss']
})
export class PageNotFoundComponent implements OnInit {

  constructor(
    private router: Router,
    private authService: AuthService
  ) { }

  selectedRole: string;


  ngOnInit() {

    console.log("___________________)");
    this.authService.isAuthenticated().subscribe(
      data => {
        console.log("panagiotis _______________");

        console.log(data[0].roles[0].value);
        this.selectedRole = data[0].roles[0].value;
      }, error => {
        this.router.navigate(['admin'])

      }
    )


  }


  navigateToHomePage() {



    console.log("Navigating to home page");
    if (this.selectedRole === 'registration_manager') {
      console.log("Navigating for registration manager___________________________");
      this.router.navigate(['/admin/users_overview']);
    } else if (this.selectedRole === 'subscriber') {
      console.log("Navigating for subscriber________________________________");
      // Navigate to subscriber page
      this.router.navigate(['admin'])

    } else if (this.selectedRole === 'operator') {
      console.log("Navigating for operator_______________________");
      // Navigate to operator page
      this.router.navigate(['admin'])

    } else {
      console.log("No role specified");
      this.router.navigate(['admin'])

    }
  }


}
